import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { noop } from "@client/shared/constants";
import style from "./style";

const AlertView = ({
  open = false,
  heading = "",
  content = "",
  positiveLabel = "Ok",
  negativeLabel = "Cancel",
  isLoading = false,
  hasCancel = false,
  preferenceName = '',
  preference = false,
  onCancel = noop,
  onSuccess = noop,
  handlePreference = noop
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
    >
      <DialogTitle sx={style.dialogTitle}>
        <IconButton onClick={onCancel}>
          <CloseIcon sx={{ color: '#B0B0B0' }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 4.5, ...style.dialogContent}}>
        <InfoOutlinedIcon fontSize="large" sx={style.warningIcon} />
        <Typography variant="h4" sx={style.heading}>
          {heading}
        </Typography>
        <Typography variant="body2">{content}</Typography>
        {preferenceName && (
          <Box sx={style.checkboxWrapper}>
            <Checkbox
              color="primary"
              checked={preference}
              onChange={(evt) => {
                const { checked } = evt.target;
                handlePreference(checked);
              }}
              sx={{ pl: 0 }}
            />
            <Typography variant="body2">Don't show this message again.</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={style.actions}>
        {hasCancel && (
          <Button
            onClick={onCancel}
            variant="outlined"
            sx={{
              ...style.actionButtons,
              ...style.cancelBtn,
            }}
          >
            {negativeLabel}
          </Button>
        )}
        <Button
          onClick={onSuccess}
          variant="contained"
          sx={style.actionButtons}
          disabled={isLoading}
        >
          {positiveLabel}
          {isLoading && (
            <CircularProgress
              size={24}
              color="inherit"
              sx={{ position: "absolute" }}
            />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertView;